"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class RunOncePerDay {
    constructor(option) {
        // get data
        this.getStorageKey = () => {
            const keyType = this.refactoryTime ? 'KeepTime' : 'KeepDays';
            const key = 'runOncePerDay' + this.callerID + this.fnID + keyType;
            return JSON.stringify(key);
        };
        this.getStoredObject = (callerID) => {
            try {
                const storedString = localStorage.getItem(this.getStorageKey());
                if (!storedString)
                    return;
                const storedObj = JSON.parse(storedString);
                return storedObj;
            }
            catch (error) {
                console.log('cannot parse JSON, return false');
                return false;
            }
        };
        this.getStoredDate = (callerID) => {
            const storedObj = this.getStoredObject(callerID);
            if (!storedObj)
                return;
            return storedObj.dayString;
        };
        this.getStoredTime = (callerID) => {
            const storedObj = this.getStoredObject(callerID);
            if (!storedObj)
                return;
            return storedObj.time;
        };
        this.getStoredFnID = (callerID) => {
            const storedObj = this.getStoredObject(callerID);
            if (!storedObj)
                return;
            return storedObj.fnID;
        };
        this.getStoredID = (callerID) => {
            const storedObj = this.getStoredObject(callerID);
            if (!storedObj)
                return;
            return storedObj.callerID;
        };
        this.getStoredResolveState = (callerID) => {
            const storedObj = this.getStoredObject(callerID);
            if (!storedObj)
                return;
            return storedObj.resolved;
        };
        this.getToday = () => new Date().toISOString().split('T')[0];
        this.getTime = () => Date.now();
        // create storage
        this.createStorage = () => {
            const storageObject = {
                callerID: this.callerID,
                fnID: this.fnID,
                dayString: this.getToday(),
                time: this.getTime(),
                resolved: false
            };
            localStorage.setItem(this.getStorageKey(), JSON.stringify(storageObject));
        };
        // update data
        this.updateStoredDate = (resolved) => {
            const storageObject = {
                callerID: this.callerID,
                fnID: this.fnID,
                dayString: this.getToday(),
                time: this.getTime(),
                resolved: resolved
            };
            localStorage.setItem(this.getStorageKey(), JSON.stringify(storageObject));
        };
        // checks
        this.ifToday = () => {
            const today = this.getToday();
            const storedDate = this.getStoredDate(this.callerID);
            const resolved = this.getStoredResolveState((this.callerID));
            if (!storedDate)
                return false;
            if (storedDate !== today || resolved !== true) {
                return 'failed';
            }
            else
                return 'passed';
        };
        this.ifInTime = () => {
            if (!this.refactoryTime)
                return false;
            const timeNow = this.getTime();
            const storedTime = this.getStoredTime(this.callerID);
            const resolved = this.getStoredResolveState((this.callerID));
            if (!storedTime)
                return false;
            const timeDiff = timeNow - storedTime;
            if (timeDiff >= this.refactoryTime || resolved !== true) {
                return 'failed';
            }
            else
                return 'passed';
        };
        // init
        this.initRunOncePerDay = () => __awaiter(this, void 0, void 0, function* () {
            const storedDate = this.getStoredDate((this.callerID));
            if (!storedDate) {
                // console.log('the run per day object is not created, create a new storage now.')
                this.createStorage();
                yield this.callBack(this.callerID);
                return;
            }
            const today = this.getToday();
            if (this.ifToday() === "failed") {
                // if (this.ifToday() === "failed" || this.ifToday() === "passed") {
                console.log('call once per day function');
                try {
                    yield this.callBack(this.callerID);
                    this.updateStoredDate(true);
                }
                catch (error) {
                    console.log(`${this.callerID} rejected.`);
                    yield (() => __awaiter(this, void 0, void 0, function* () {
                        if (this.rejCallBack) {
                            yield this.rejCallBack();
                        }
                    }))();
                    this.updateStoredDate(false);
                }
                return;
            }
            if (this.ifToday() === "passed") {
                // console.log(`the function ID: ${this.callerID} is already resolved today`)
                return;
            }
            else {
                console.log('other issues');
                return;
            }
        });
        this.initRunOncePerTmie = () => __awaiter(this, void 0, void 0, function* () {
            const storedDate = this.getStoredDate((this.callerID));
            if (!storedDate) {
                // console.log('the run per day object is not created, create a new storage now.')
                this.createStorage();
                yield this.callBack(this.callerID);
                return;
            }
            if (this.ifInTime() === "failed") {
                // if (this.ifToday() === "failed" || this.ifToday() === "passed") {
                console.log('call once per day function');
                try {
                    yield this.callBack(this.callerID);
                    this.updateStoredDate(true);
                }
                catch (error) {
                    console.log(`${this.callerID} rejected.`);
                    yield (() => __awaiter(this, void 0, void 0, function* () {
                        if (this.rejCallBack) {
                            yield this.rejCallBack();
                        }
                    }))();
                    this.updateStoredDate(false);
                }
                return;
            }
            if (this.ifInTime() === "passed") {
                return;
            }
            else {
                console.log('other issues');
                return;
            }
        });
        this.callerID = option.callerID;
        this.callBack = option.callBack;
        this.fnID = option.fnID;
        option.refactoryTime ? this.refactoryTime = option.refactoryTime : this.refactoryTime = undefined;
        option.rejCallBack ? this.rejCallBack = option.rejCallBack : this.rejCallBack = undefined;
        if (this.refactoryTime) {
            this.initRunOncePerTmie();
            return;
        }
        this.initRunOncePerDay();
    }
}
